import { useState } from "react";

const WhatsAppChat = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [userMessage, setUserMessage] = useState("");
  const whatsappNumber = "+447871092759"; // Hardcoded WhatsApp number

  const toggleChatBox = (event) => {
    event.preventDefault();
    setIsChatOpen(!isChatOpen);
  };

  const closeChatBox = () => {
    setIsChatOpen(false);
  };

  const sendMessage = () => {
    const fullUrl = window.location.href;
    const whatsappUrl = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(
      userMessage
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <div>
      <a
        className="whatsapp-icon"
        href="javascript:void(0)"
        onClick={toggleChatBox}
      >
        <img
          alt="icon"
          height="50px"
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/767px-WhatsApp.svg.png"
          width="50px"
        />
      </a>

      {isChatOpen && (
        <div className="chat-box">
          <div className="chat-header">
            Chat with us on WhatsApp
            <span className="close-btn" onClick={closeChatBox}>
              ×
            </span>
          </div>
          <div className="chat-body">
            <p>Thanks for contacting us! Please write your query below:</p>
            <textarea
              value={userMessage}
              onChange={(e) => setUserMessage(e.target.value)}
              placeholder="Type your message here..."
            ></textarea>
            <button onClick={sendMessage}>Send</button>
          </div>
        </div>
      )}

      <style jsx>{`
        .whatsapp-icon {
          position: fixed;
          width: 60px;
          height: 60px;
          bottom: 40px;
          right: 40px;
          color: #fff;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 30px;
          text-decoration: none;
          box-shadow: 2px 2px 3px #999;
          z-index: 100;
        }

        .chat-box {
          position: fixed;
          bottom: 100px;
          right: 40px;
          width: 300px;
          background: white;
          border: 1px solid #ccc;
          border-radius: 10px;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
          z-index: 101;
        }

        .chat-header {
          background: #25d366;
          color: white;
          padding: 10px;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          text-align: center;
          font-weight: bold;
          position: relative;
        }

        .close-btn {
          position: absolute;
          right: 10px;
          top: 10px;
          cursor: pointer;
          font-size: 20px;
          color: white;
        }

        .chat-body {
          padding: 10px;
        }

        .chat-body textarea {
          width: 100%;
          height: 60px;
          border: 1px solid #ccc;
          border-radius: 5px;
          padding: 5px;
          margin-bottom: 10px;
        }

        .chat-body button {
          width: 100%;
          padding: 10px;
          background: #25d366;
          color: white;
          border: none;
          border-radius: 5px;
          font-weight: bold;
          cursor: pointer;
        }

        .chat-body button:hover {
          background: #1ebe5a;
        }
      `}</style>
    </div>
  );
};

export default WhatsAppChat;
